'use strict';

export const FORM_FIELD_ERRORS = {
	FORM_SLUG_FIELD_WRONG_FORMAT: 'Wrong format. Must only contain lower case latin letters, numbers and hyphens.',
};
